
import Stacks from "../../../assets/outline/Stacks.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StacksIcon({ className, dataTestid = "StacksIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Stacks data-testid={dataTestid} className={classes} {...rest} />
  );
}
